<template>
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
               <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#location"
                  aria-controls="location">
                  
                  <span>
                    <img src="../assets/logo.png" style="    width: 200px;">
                  </span>
                  <span class="weather-container">
                    <i class="bi bi-thermometer "></i> {{ current_temperature?(current_temperature).toFixed(1):'' }}
                  </span>
               </a>
               <div class="d-flex align-items-center gap-2 ms-auto">
                  <a href="profile.html" class="link-dark">
                     <div class="bg-dark bg-opacity-75 rounded-circle user-icon"><i class="bi bi-person d-flex m-0 h4 text-white"></i></div>
                  </a>
                  <a class="toggle" href="#">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-list d-flex m-0 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            <!-- <div class="pt-3">
               
               <a href="#" data-bs-toggle="offcanvas" data-bs-target="#searchoffcanvas"
                  aria-controls="searchoffcanvas">
                  <div class="input-group bg-white rounded-3 shadow-sm py-1">
                     <input type="text" class="form-control bg-transparent border-0 rounded-0 px-3"
                        placeholder="Search here for more" aria-label="Search here for"
                        aria-describedby="search">
                     <span class="input-group-text bg-transparent border-0 rounded-0 pe-3" id="search"><i
                        class="icofont-search-1"></i></span>
                  </div>
               </a>
            </div> -->
         </div>
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
            <!-- shop by category -->
   
            <!-- Top Evets -->
            <div class="pt-3">
                <div class="d-flex align-items-center justify-content-between px-3 pb-3">
                   <h5 class="fw-bold text-black mb-0">Trending Business</h5>
                </div>
             
                <div class="row">
                   <div class="col-md-4 mb-4" v-for="(business, i) in listings" :key="i">
                      <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3">
                         <a href="product-detail.html" class="link-dark">
                            <div class="bg-light rounded-4 p-4 position-relative product-box">
                               <img src="https://mh13.dktsoft.in/public/uploads/category/1740554531_1460479d6681660dafd8.jpg" 
                                    alt="" class="img-fluid h-100 d-block mx-auto">
                            </div>
                         </a>
                         <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                            <b>{{ business.offer }}</b><br>
                         </div>
                         <div class="card-body p-0">
                            <small class="text-muted">{{ business.catname }}</small>
                            <h6 class="card-title fw-bold">{{ business.name }}</h6>
                         </div>
                         <div class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                            <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm col-12">View</a>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
             
            <!-- Top Picks -->
       
             <!-- Top Picks -->
           
            <!-- coupons -->
      
            <!-- must have items -->
       
            <!-- banner -->
        
         </div>
         <!-- category button -->
         <div class="btn-category">
            <a href="#" class="btn btn-primary rounded-circle shadow-sm icon-lg" data-bs-toggle="modal"
               data-bs-target="#categories">
            <i class="icofont-food-basket icofont-3x text-white"></i>
            </a>
         </div>
         <!-- footer -->
         <div class="footer bg-white shadow mt-auto border-top">
            <div class="d-flex align-items-center justify-content-between py-1">
               <a href="index.html" class="link-dark text-center col py-2 p-1">
                  <i class="bi bi-house h3 m-0"></i>
                  <p class="small m-0 pt-1">Home</p>
               </a>
               <a href="listing.html" class="text-muted text-center col py-2 p-1">
                  <i class="bi bi-shop h3 m-0"></i>
                  <p class="small m-0 pt-1">Shop</p>
               </a>
               <a href="track-delivery-boy.html" class="text-muted text-center col py-2 p-1">
                  <i class="bi bi-geo-alt h3 m-0"></i>
                  <p class="small m-0 pt-1">Track</p>
               </a>
               <a href="cart.html" class="text-muted text-center col py-2 p-1">
                  <i class="bi bi-basket h3 m-0"></i>
                  <p class="small m-0 pt-1">Cart</p>
               </a>
               <a href="profile.html" class="text-muted text-center col py-2 p-1">
                  <i class="bi bi-person h3 m-0"></i>
                  <p class="small m-0 pt-1">Profile</p>
               </a>
            </div>
         </div>
      </div>
</template>
<style>
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
</style>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'HomeView',
  components: { 
  },
  mounted() {
    // this.initializeHomeContent();
      var $main_nav = $('#main-nav');
    var $toggle = $('.toggle');
    var defaultOptions = {
        disableAt: false,
        customToggle: $toggle,
        levelSpacing: 40,
        navTitle: 'App',
        levelTitles: true,
        levelTitleAsBack: true,
        pushContent: '#container',
        insertClose: 2
    };
    var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    
    this.fetchWeather();
    this.getHomeBasic(); // Call the method here
},
  data() {
    return {
      loading:false,
      error:null,
      categories:[{name:"Event"},{name:"Food"},{name:"Offers"},{name:"News"},{name:"Properties"},],
      listings:[{name:"DK",business:"Software",offer:"10% Off"},{name:"Shree Computer",business:"Software",offer:"10% Off"},{name:"Corner Crunch",business:"Hotel",offer:"20% Off"}],
      events:[{name:"Hasya jatra",location:"Hutatma",cost:"200 ",time:"6PM "},{name:"Lavanya Khani",location:"Hutatma",cost:"200 ",time:"10PM "},{name:"Cricket",location:"Part Maidan",cost:"200 ",time:"4PM "}],
      properties:[
        {name:"2BHK Near Avanti nagar",area:"2000sqft",persqft:"2000 ",type:"Residendial "},
        {name:"1BHK Near Bajaj nagar",area:"2500sqft",persqft:"5000 ",type:"Commercial "},
        {name:"Open Plot Near Highway",area:"2000sqft",persqft:"2000 ",type:"Residendial "},],
        current_temperature:0,
     


    }
  },
  methods:{
    initializeHomeContent(){
    

    // Coupons
    $('.coupons').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1.3,
        slidesToScroll: 1,
    });

    // Top Picks - Homepage
    $('.top-picks').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });

    // All Categories - Homepage
    $('.all-cate').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 4.5,
        slidesToScroll: 3,
    });

    // Product Detail
    $('.product-slider').slick({
        arrows: false,
        autoplay: true,
        infinite: false,
        dots: true,
    });
    // this.getHomeBasic();
    }
,
async fetchWeather() {
      const url =
        "https://api.open-meteo.com/v1/forecast?latitude=17.6599&longitude=75.9064&hourly=apparent_temperature&timezone=auto&forecast_days=1";

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Weather data not available");
        const data = await response.json();
        
        // Get the latest hourly temperature
        if (data.hourly && data.hourly.apparent_temperature.length > 0) {
          this.current_temperature = data.hourly.apparent_temperature[0]; // First hour's temperature
        }
      } catch (error) {
        console.error("Error fetching weather:", error);
      }
    }, 
    async getHomeBasic() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getfrontview").then((response) => {
            self.categories = response.data.app_categories;
            self.events = response.data.events;
            self.listings = response.data.businesslisting;
            self.properties = response.data.properties;
            
            
        
          }).then(() => {
               self.initializeHomeContent();
          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 
  }
}
</script>
